// Tipovi i konstante
import { ContractSearchPageCmp, ContractSearchPageProps } from "./types";

// UI komponente
import { PageHeader } from "ui/components/PageHeader";
import { PageTitle } from "ui/components/PageTitle";

// Moduli specifični za projekt
import { Routes } from "ui/modules/finance/navigation";

// Lokalne komponente
import ContractSaleSearchPage from "./components/ContractSaleSearchPage/ContractSaleSearchPage";
import ContractRentSearchPage from "./components/ContractRentSearchPage/ContractRentSearchPage";
import { CONTRACT_SEARCH_PAGE_TITLE } from "ui/components/PageTitle/consts";
import { useTranslate } from "helpers";
import { Tabs } from "ui/components/Tabs";
import { Breadcrumb } from "ui/components/Breadcrumb";



const ContractSearchPage: ContractSearchPageCmp = (
  props: ContractSearchPageProps
) => {

  const { t } = useTranslate();

  return (
    <>
      <div className="">
        <div className="bg-white rounded-t-md border border-b mb-2">
          <PageHeader>
            <div className="flex gap-3">
              <div>
                <PageTitle
                  title={`${t(CONTRACT_SEARCH_PAGE_TITLE.text)}`}
                  icon={CONTRACT_SEARCH_PAGE_TITLE.icon}
                  iconColor={CONTRACT_SEARCH_PAGE_TITLE.iconColor}
                />
                <Breadcrumb />
              </div>
            </div>
          </PageHeader>
        </div>
        <Tabs
          tabs={[
            {
              label: t("admin.finance.contract.search.tab.sale"),
              queryParam: "sale",
              content: (
                <div>
                  <ContractSaleSearchPage />
                </div>
              ),
            },
            {
              label: t("admin.finance.contract.search.tab.rent"),
              queryParam: "rent",
              content: (
                <div>
                  <ContractRentSearchPage />
                </div>
              ),
            },
            {
              label: t("admin.finance.contract.search.tab.stats"),
              queryParam: "stats",
              content: (
                <div>

                </div>
              ),
            },
          ]}
        />

      </div>

    </>
  );
};

ContractSearchPage.route = Routes.ContractSearchPageRouter;

export default ContractSearchPage;
